<template>
  <div>
    <h1>Edit {{ retrieved && retrieved['@id'] }}</h1>

    <div
      v-if="created"
      class="alert alert-success"
      role="status">{{ created['@id'] }} created.</div>
    <div
      v-if="updated"
      class="alert alert-success"
      role="status">{{ updated['@id'] }} updated.</div>
    <div
      v-if="isLoading || deleteLoading"
      class="alert alert-info"
      role="status">Loading...</div>
    <div
      v-if="error"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true">{{ error }}</span>
    </div>
    <div
      v-if="deleteError"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true">{{ deleteError }}</span>
    </div>

    <SpeakerForm
      v-if="retrieved"
      :handle-submit="onSendForm"
      :values="retrieved"
      :errors="violations"
      :initial-values="retrieved" />

    <div class="my-3">
      <router-link
        v-if="retrieved"
        :to="{ name: 'SpeakerList' }"
        class="btn btn-primary mr-3">Back to list</router-link>
      <button
        class="btn btn-danger"
        @click="del">Delete</button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import SpeakerForm from './Form.vue';

export default {
  components: {
    SpeakerForm,
  },

  computed: {
    ...mapFields('speaker/del', {
      deleteError: 'error',
      deleteLoading: 'isLoading',
      deleted: 'deleted',
    }),
    ...mapFields('speaker/create', {
      created: 'created',
    }),
    ...mapFields('speaker/update', {
      isLoading: 'isLoading',
      error: 'error',
      retrieved: 'retrieved',
      updated: 'updated',
      violations: 'violations',
    }),
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function(deleted) {
      if (!deleted) {
        return;
      }

      this.$router.push({ name: 'SpeakerList' });
    },
    updated: function(updated) {
       if (!updated) {
        return;
      }
      this.$router.push({ name: 'SpeakerList' });
    }
  },

  beforeDestroy() {
    this.reset();
  },

  created() {
    this.retrieve(decodeURIComponent(this.$route.params.id));
  },

  methods: {
    ...mapActions({
      createReset: 'speaker/create/reset',
      deleteItem: 'speaker/del/del',
      delReset: 'speaker/del/reset',
      retrieve: 'speaker/update/retrieve',
      updateReset: 'speaker/update/reset',
      update: 'speaker/update/update',
      updateRetrieved: 'speaker/update/updateRetrieved',
    }),

    del() {
      if (window.confirm('Are you sure you want to delete this speaker ?')) {
        this.deleteItem(this.retrieved);
      }
    },

    reset() {
      this.updateReset();
      this.createReset();
    },

    onSendForm(data) {
      this.update(data);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/speaker/Update.vue